export default "__VITE_ASSET__Bx9a_8mR__"